import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CreateSaq from "../../components/CreateSaq";
// import CompletedSaqs from "../../components/CompletedSaqs";

import { images } from "../../helpers/images";

// import logo from "../../static/images/tg-logo.svg";

import {
  callApiSaqsFind,
  callApiDownloadSaqPdf,
  callApiUpdateUserPassword,
} from "../../services";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { authUserData } from "../../helpers";
import Header from "../../components/Header";
import DeleteConfirmationModal from "../../components/modals/DeleteConfirmationModal";

class Completed extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      draftSaqData: null,
      completedSaqData: null,
      deletedId: null,
      showModal: false,
    };
  }

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    this.setState({ showModal: false });
  };

  componentDidMount = async () => {
    const userData = authUserData();

    // console.log("useData Dashboard", userData.userId);

    /* const tempPassword = await this.makeTempPassword();
    const userId = userData && userData.userId;
    callApiUpdateUserPassword(userId, { password: tempPassword }).then(
      (resData) => {
        
      }
    ); */

    callApiSaqsFind({ userId: userData.userId })
      .then((res) => {
        // console.log("api res", res);
        if (res.success && res.data && res.data.length > 0) {
          const draftList = res.data.filter((v, i) => {
            return v.status === "draft";
          });

          const completedList = res.data.filter((v, i) => {
            return v.status === "completed";
          });

          // console.log("completedList", completedList);

          this.setState({
            draftSaqData: draftList,
            completedSaqData: completedList,
          });
        }
      })
      .catch((error) => {
        // console.log("Dashboard fetch saq data ... error", error);
      });
  };

  onClickDeleteSaq = (saqId) => {
    console.log("onClickDeleteSaq", saqId);
    this.setState(
      {
        deletedId: saqId,
      },
      () => {
        // document.getElementById("btnOpenSaqDeleteConfirmationModal").click();
        this.setState({ showModal: true });
      },
    );
  };

  downloadSaqPdf = async (saqId) => {
    try {
      const res = await callApiDownloadSaqPdf({ saqId: saqId });

      if (!res || !res.success || !res.data) {
        console.error("downloadSaqPdf: invalid API response", res);
        alert("Could not generate the SAQ PDF. Please try again.");
        return;
      }

      const fileUrl = `${process.env.REACT_APP_API_URL}/${res.data}`;
      const response = await fetch(fileUrl);

      if (!response.ok) {
        console.error(
          "downloadSaqPdf: fetch failed",
          response.status,
          fileUrl,
        );
        alert("Could not download the SAQ PDF. Please try again.");
        return;
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = res.data;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("downloadSaqPdf: unexpected error", error);
      alert("Could not download the SAQ PDF. Please try again.");
    }
  };

  onSelectAction = (type, saqId, saqType) => {
    console.log("type", type);
    console.log("saqId", saqId);
    switch (type) {
      case "edit":
        this.props.history.push("/saq-draft/" + saqType + "/" + saqId);
        break;
      case "delete":
        this.onClickDeleteSaq(saqId);
        break;
      case "downloadPdf":
        this.downloadSaqPdf(saqId);
        setTimeout(() => {
          document.getElementById(saqId).selectedIndex = 0;
        }, 2500);
        break;
      default:
        break;
    }
  };

  render() {
    const { history } = this.props;
    const { draftSaqData, completedSaqData, deletedId, showModal } = this.state;

    return (
      <>
        <div className="cell small-12 medium-10" id="maincontent">
          <Header />
          <div id="body-content">
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="cell small-12 medium-12" id="completedsaqs">
                <h3>COMPLETED SAQ's</h3>
                <br />
                <div id="compltedsaqs-table">
                  <table>
                    <thead>
                      <tr>
                        <th width="200">Website</th>
                        <th>SAQ Type</th>
                        <th width="150">Last Updated</th>
                        <th width="150">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {completedSaqData && completedSaqData.length > 0 ? (
                        completedSaqData.map((v, i) => {
                          return (
                            <tr key={uuidv4()}>
                              <td>{v.domain}</td>
                              <td>{v.type}</td>
                              <td>
                                {moment(v.createdAt).format("MMMM Do YYYY")}
                              </td>
                              <td>
                                <select
                                  id={v._id}
                                  onChange={(e) =>
                                    this.onSelectAction(
                                      e.target.value,
                                      v._id,
                                      v.type,
                                    )
                                  }
                                >
                                  <option>Options</option>
                                  <option value="edit">Edit</option>
                                  <option value="delete">Delete</option>
                                  <option value="downloadPdf">
                                    Download PDF
                                  </option>
                                </select>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="3">No records.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <DeleteConfirmationModal
          history={this.props.history}
          deletedId={deletedId}
          showModal={showModal}
          onCloseModal={() => this.onCloseModal()}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Completed);
